"use client";

import Image from "next/image";
import classes from "./HeroSection.module.css";

import "swiper/css";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";

import Link from "next/link";
import { CSSProperties } from "react";
import { Autoplay, Pagination } from "swiper/modules";
import SectionHeader from "../../components/SectionHeader";

import { getPageRoute, getS3ImageUrl } from "@/utils/routes";

interface Props extends WidgetSectionProps {
	images: ImageType[];
	sectionHeader?: SectionHeaderType;
	py?: number | string;
	pb?: number | string;
	pt?: number | string;
	noContainer?: boolean;
	settings?: any;
}

const HeroSection = ({
	images: _images,
	sectionHeader,
	py,
	pb,
	pt,
	noContainer = false,
	settings: _settings,

	widget,
}: Props) => {
	const styles: CSSProperties = {};

	if (py !== undefined) styles.padding = py + "px";
	if (pb !== undefined) styles.paddingBottom = pb + "px";
	if (pt !== undefined) styles.paddingTop = pt + "px";

	const banners = widget?.data?.images || [];
	const settings = widget?.data?.settings || {};

	if (banners.length === 0) return null;

	const width = settings?.width || 1920;
	const height = settings?.height || 710;
	const autoplay = settings?.autoplay ? true : false;
	const delay = settings?.delay || 5000;

	return (
		<div className={classes.HeroSection} style={styles}>
			{sectionHeader && (
				<SectionHeader
					title={sectionHeader.title || "Title"}
					btnText={sectionHeader.linkTitle}
					link={sectionHeader.link}
				/>
			)}

			<div
				className={
					settings?.containerType === "full"
						? ""
						: "container" + (noContainer ? "not" : "")
				}>
				<div className={`${classes.slider} herroSlider`}>
					<Swiper
						spaceBetween={0}
						slidesPerView={1}
						autoplay={autoplay && {
							delay: delay,
							disableOnInteraction: false,
						}}
						pagination={{
							clickable: true,
						}}
						modules={[Autoplay, Pagination]}>
						{banners?.map((image, index) => (
							<SwiperSlide key={index}>
								<div className={classes.slide}>
									<Link
										href={getPageRoute(
											image.link?.urlType || "custom",
											image.link?.url || ""
										)}
										passHref>
										<Image
											src={getS3ImageUrl(image.image)}
											alt={`slide ${index}`}
											blurDataURL={
												"https://www.unfe.org/wp-content/uploads/2019/04/SM-placeholder.png"
											}
											placeholder="blur"
											layout="responsive"
											width={width}
											height={height}
											style={{
												aspectRatio: width / height,
												objectFit: "cover",
											}}
											className={classes.image}
											unoptimized={true}
										/>
									</Link>
								</div>
							</SwiperSlide>
						))}
					</Swiper>
				</div>
			</div>
		</div>
	);
};

export default HeroSection;
